export const actionTypes = {
  UPDATE_GENERAL_SETTINGS: "[GENERAL SETTINGS] Update general settings ",
};

export const INITIAL_STATE = {
  initialized: false,
};

export const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.UPDATE_GENERAL_SETTINGS:
      payload.initialized = true;
      return { ...state, ...payload };

    default:
      return state;
  }
};

export const actions = {
  updateGeneralSettings: (payload) => ({
    type: actionTypes.UPDATE_GENERAL_SETTINGS,
    payload,
  }),
};
